var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 132,
    viewBox: "0 0 123 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04321 13.8077C2.04321 6.26577 8.16129 0.151855 15.7083 0.151855H106.484C114.031 0.151855 120.149 6.26578 120.149 13.8077V104.521C120.149 112.063 114.031 118.177 106.484 118.177H15.7083C8.16128 118.177 2.04321 112.063 2.04321 104.521V13.8077Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.484 1.12727H15.7083C8.70036 1.12727 3.01929 6.80448 3.01929 13.8077V104.521C3.01929 111.525 8.70036 117.202 15.7083 117.202H106.484C113.492 117.202 119.173 111.525 119.173 104.521V13.8077C119.173 6.80448 113.492 1.12727 106.484 1.12727ZM15.7083 0.151855C8.16129 0.151855 2.04321 6.26577 2.04321 13.8077V104.521C2.04321 112.063 8.16128 118.177 15.7083 118.177H106.484C114.031 118.177 120.149 112.063 120.149 104.521V13.8077C120.149 6.26578 114.031 0.151855 106.484 0.151855H15.7083Z",
    fill: "#0865FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49121 20.3047C9.49121 12.698 15.5995 6.53162 23.1345 6.53162H100.121C107.656 6.53162 113.765 12.698 113.765 20.3047V98.0243C113.765 105.631 107.656 111.797 100.121 111.797H23.1345C15.5995 111.797 9.49121 105.631 9.49121 98.0243V20.3047Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.121 7.51541H23.1345C16.1377 7.51541 10.4657 13.2414 10.4657 20.3047V98.0243C10.4657 105.088 16.1377 110.814 23.1345 110.814H100.121C107.118 110.814 112.79 105.088 112.79 98.0243V20.3047C112.79 13.2414 107.118 7.51541 100.121 7.51541ZM23.1345 6.53162C15.5995 6.53162 9.49121 12.698 9.49121 20.3047V98.0243C9.49121 105.631 15.5995 111.797 23.1345 111.797H100.121C107.656 111.797 113.765 105.631 113.765 98.0243V20.3047C113.765 12.698 107.656 6.53162 100.121 6.53162H23.1345Z",
    fill: "#0865FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.979248 130.405C0.979248 129.524 1.63618 128.81 2.44656 128.81H120.81C121.62 128.81 122.277 129.524 122.277 130.405C122.277 131.286 121.62 132 120.81 132H2.44656C1.63618 132 0.979248 131.286 0.979248 130.405Z",
    fill: "#0865FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatic);
export default __webpack_public_path__ + "static/media/static.81a383b8da4985cf3a78c2f03eacbfa8.svg";
export { ForwardRef as ReactComponent };